export const enum ClientPageTabViewEvent {
  update = 'update',
}
